<div [class]="'card-tramite '+styleClass" [ngClass]="classCard " *ngIf="item">
  @if (_styleContent == 'card') {
    <div class="header-card align-items-center">
      <div class="flex w-full mb-1">
        <img class="img-header-card align-self-start" [src]="'assets/img/icons-principal/ico-checkmark.svg'"
             alt="Checkmark icon">
        <div class="inline-flex w-full">
          <h2 class="title-card flex-70 cursor-pointer align-self-start"
              [routerLink]="['/' +basePath +
               '/informacion/', item.id, item.dependenciaId]"
              [queryParams]="{ search: text }">{{ item.descripcion }}</h2>
          <div class="flex-30 flex justify-content-end align-self-start">
          <span [pTooltip]="iniciarTramiteTooltip(item) | translate"
                [tooltipDisabled]="!iniciarTramiteDisabled(item)" tooltipPosition="top">
            <button pButton [label]="'components.app-resultados-busqueda.iniciar-tramite' | translate"
                    class="hidden sm:flex font-normal bg-button-outline-blue-light
                     border-outline-blue-light text-blue-general"
                    icon="pi pi-chevron-right" iconPos="right"
                    (click)="onInitTramite()" type="button"
                    [disabled]="iniciarTramiteDisabled(item)"></button>
          </span>
          </div>
        </div>
      </div>
    </div>
    <div class="flex align-items-baseline " style="margin-left: 1.8rem">
      <div class="subtitle">
        <p>{{ item.dependencia }}</p>
      </div>
    </div>
    <div class="content-card ">
      <p class="text-content">
        {{ item.descripcion }}
      </p>
      <p class="text-content">
        {{ 'common.valor' | translate }} : {{ item.valor | currency:'COP':'symbol-narrow':'1.0-0' }}
      </p>
    </div>
    <div class="card-footer  hidden md:flex">
    <span  [pTooltip]="iniciarTramiteTooltip(item)" [tooltipDisabled]="!iniciarTramiteDisabled(item)"
          tooltipPosition="top">
      <button pButton type="button" class="sm:hidden relative font-normal border-outline-blue-light
      bg-button-outline-blue-light text-blue-general"
              [label]="'components.app-resultados-busqueda.iniciar-tramite' | translate " icon="pi pi-chevron-right"
              (click)="onInitTramite()" iconPos="right" [disabled]="iniciarTramiteDisabled(item)">
      </button>
    </span>
    </div>
  } @else {
    <div class="header-card align-items-center">
      <div class="flex w-full mb-1">
        <span class="font-principal bold font-18 mr-2" *ngIf="index != undefined">{{ index + 1 }}</span>
        <div class="flex-colunm w-full">
          <h2 class="title-card flex-70 cursor-pointer align-self-start underline"
              [routerLink]="['/' +basePath + '/informacion/', item.id, item.dependenciaId]"
              [queryParams]="{ search: text }">
            {{ item.title ?? item.descripcion }}
          </h2>
          <p class="brand-blue-light mt-2">{{ item.dependencia }}</p>
          <p class="app-text-gray font-13 description-item" style="max-height:55px;">
            {{ item.descripcion }}
           </p>
          <p class="text-content app-text-gray">
            {{ 'common.valor' | translate }} : {{ item.valor | currency:'COP':'symbol-narrow':'1.0-0' }}
          </p>
          <div class="gap-3 hidden sm:flex">
            <button pButton type="button" class="font-normal border-outline-blue-light
                bg-button-outline-blue-light text-blue-general"
                    [pTooltip]="'msg.tramiteInactivo' | translate"
                    [tooltipDisabled]="!(item.requierePago && !item.costoVigente)" tooltipPosition="top"
                    [label]="'components.app-resultados-busqueda.iniciar-tramite' | translate "
                    icon="pi pi-chevron-right"
                    (click)="onInitTramite()" iconPos="right"
                    [disabled]="item.requierePago && !item.costoVigente">
            </button>
            <button pButton type="button" class="font-normal border-outline-blue-light
                    bg-button-outline-blue-light text-blue-general" iconPos="right" (click)="consultaEstado()"
                    [label]="'components.app-item-resultado.consulta-estado-tramite' | translate "
                    icon="pi pi-chevron-right">
            </button>

          </div>
        </div>
        <p-divider layout="vertical"
                   class="my-2 hidden sm:flex"/>
        <div class="flex-30 hidden sm:flex flex-column">
          <p class="app-text-gray">
            <i class="pi pi-desktop mr-2"></i>
            <span class="font-medium font-12"> {{ 'components.app-item-resultado.tramite-en-linea' | translate }}</span>
          </p>
          <p class="app-text-gray">
            <i class="pi pi-dollar mr-2"></i>
            <span class="font-medium font-12">{{   'components.app-item-resultado.tramite-'+ (item.requierePago ? 'con' : 'sin') + '-costo' | translate }}</span>
          </p>

          <div class="app-text-gray flex mt-3">
              <i class="pi pi-clock mr-2 "></i>
            <p class="mt-0">
              <span
                class="font-medium font-12">{{ 'components.app-item-resultado.duracion-estimada' | translate }}</span>
              <span class="font-normal mt-1 block font-12">{{ item.plazo }}</span>
            </p>

          </div>
        </div>
      </div>
    </div>
  }

</div>
